import { getInstance } from './getInstance'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useI18n () {
  const vm = getInstance()
  return vm.proxy.$i18n
}
